// src/components/Loader/ButtonLoader.jsx
export default function ButtonLoader({ label = "Please wait…" }) {
  return (
    <span className="btn-loader">
      <span className="btn-loader-spinner" aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
